import type React from "react";
import type {ReactNode} from "react";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";

type Props = {
    /** page: centred in the gallery; inline: a dashed box inside a section; canvas: fills the dashboard area. */
    variant: "page" | "inline" | "canvas";
    title?: ReactNode;
    body?: ReactNode;
    /** Shows the dashboard glyph above the title. */
    icon?: boolean;
    /** A button under the text. */
    action?: ReactNode;
    role?: "alert";
};

const VARIANT_CLASS = {page: "", inline: " dsh-empty--inline", canvas: " dsh-empty--canvas"} as const;

/** Empty, no-match and error states of the Dashboards module. */
export const DashboardsEmptyState: React.FC<Props> = ({variant, title, body, icon = false, action, role}) => (
    <div className={`dsh-empty${VARIANT_CLASS[variant]}`} role={role}>
        {icon && <DashboardOutlinedIcon sx={{fontSize: 28}}/>}
        {title && <p className="dsh-t-card-title">{title}</p>}
        {body && <p className="dsh-t-body-sm">{body}</p>}
        {action}
    </div>
);
